import { MessageCircle } from 'lucide-react';
import { Commentable } from '@/shared/comments/Commentable';
import { useChat } from '@/versions/v1/shared/ChatContext';
import { ChatShell } from './chat/ChatShell';

/** Docked AI rail for non-chat-first routes (settings, admin, project modules). */
export function AIRail() {
  const { railOpen, openRail, closeRail } = useChat();

  if (!railOpen) {
    return (
      <Commentable name="AIRail">
        <button
          type="button"
          className="ai-fab"
          onClick={() => openRail()}
          title="Open AI assistant"
          aria-label="Open AI assistant"
        >
          <MessageCircle size={20} aria-hidden="true" />
        </button>
      </Commentable>
    );
  }

  return (
    <Commentable name="AIRail">
      <aside
        className="relative flex h-full w-full flex-col bg-[var(--background)]"
        aria-label="AI assistant"
        style={{ ['--thread-max-width' as string]: '44rem' }}
      >
        <ChatShell
          helpDoc="workspace/chat-rail"
          helpLabel="Chat rail"
          showMinimize
          onMinimize={() => closeRail()}
          storageKey="mock-ui:docked-rail-chat-files"
        />
      </aside>
    </Commentable>
  );
}
